function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5906"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5906"] = parcelRequire;
}
parcelRequire.register("9wJdH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6efa2df7948f6795$export$6503ec6e8aabbaf; }, function (v) { return $6efa2df7948f6795$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $6efa2df7948f6795$export$f7ad0328861e2f03; }, function (v) { return $6efa2df7948f6795$export$f7ad0328861e2f03 = v; });
var $6efa2df7948f6795$export$6503ec6e8aabbaf;
var $6efa2df7948f6795$export$f7ad0328861e2f03;
"use strict";
var $6efa2df7948f6795$var$mapping = {};
function $6efa2df7948f6795$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$6efa2df7948f6795$var$mapping[keys[i]] = pairs[keys[i]];
}
function $6efa2df7948f6795$var$resolve(id) {
    var resolved = $6efa2df7948f6795$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$6efa2df7948f6795$export$6503ec6e8aabbaf = $6efa2df7948f6795$var$register;
$6efa2df7948f6795$export$f7ad0328861e2f03 = $6efa2df7948f6795$var$resolve;

});

var $2026dc23580a46a7$exports = {};

(parcelRequire("9wJdH")).register(JSON.parse('{"kSOE2":"index.d1a39a62.js","LiiNZ":"FoodLogo.0e921e3d.png","7lZjb":"AboutImage.aa9d90b8.jpg","bYLRz":"app_store.90a92e73.png","6ooWt":"play_store.4caa5192.jpg","b5l0J":"FoodImage2.d39812e7.png","6rLAE":"google.b9f7e6d9.png","gDxht":"FoodImage1.a2a2656b.png","4II5v":"DemoImage.a9c94cae.jpg","gzrhQ":"EmptyCart.fc3619c3.png","6CTFQ":"HomePage.786df513.js","iGZ15":"FoodImagePage.543b04df.png","jf007":"HomePage.cb35aafc.css","doDm0":"Menu.e152d13d.js","fnYTQ":"RestaurantMenu.cbdfe2c0.js","fVlgR":"index.73444f7d.css"}'));


//# sourceMappingURL=index.b3001a9a.js.map
